import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["triggerElement", "content", "isOpen", "onInteractOutside", "side", "align", "onEscapeKeyDown"];
import React from "react";
import { FLOATING_ELEMENT_SIDE_OFFSET } from "../DropdownMenu/constants";
import { PopoverContent, PopoverRoot, PopoverTrigger } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Popover(_ref) {
  var triggerElement = _ref.triggerElement,
    content = _ref.content,
    isOpen = _ref.isOpen,
    onInteractOutside = _ref.onInteractOutside,
    side = _ref.side,
    align = _ref.align,
    onEscapeKeyDown = _ref.onEscapeKeyDown,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(PopoverRoot, _extends({
    open: isOpen
  }, restProps, {
    children: [/*#__PURE__*/_jsx(PopoverTrigger, {
      asChild: true,
      children: /*#__PURE__*/_jsx("span", {
        children: triggerElement
      })
    }), /*#__PURE__*/_jsx(PopoverContent, {
      sideOffset: FLOATING_ELEMENT_SIDE_OFFSET,
      side: side,
      align: align,
      onInteractOutside: onInteractOutside,
      onOpenAutoFocus: function onOpenAutoFocus(event) {
        return event.preventDefault();
      },
      onEscapeKeyDown: onEscapeKeyDown,
      children: content
    })]
  }));
}
export default Popover;